(() => {
  const init = () => {
    const overlay = document.querySelector('.lcg-search.lcg-search--v2');
    const trigger = document.querySelector('.lcg-search-trigger');
    if (!overlay || !trigger || overlay.dataset.cabaneSearchReady === 'true') return;

    overlay.dataset.cabaneSearchReady = 'true';
    const panel = overlay.querySelector('.lcg-search__panel');
    const closeButton = overlay.querySelector('.lcg-search__close');
    const backButton = overlay.querySelector('.lcg-search__back');
    const clearButton = overlay.querySelector('.lcg-search__clear');
    const input = overlay.querySelector('.lcg-search__input');
    const defaultView = overlay.querySelector('[data-search-default]');
    const resultsView = overlay.querySelector('[data-search-results]');
    const form = overlay.querySelector('.lcg-search__form');
    // The magnifier is decoration; only the text area opens the search.
    const submitIcon = overlay.querySelector('.lcg-search__submit-icon');
    if (submitIcon) {
      const decoration = document.createElement('span');
      decoration.className = submitIcon.className;
      decoration.setAttribute('aria-hidden', 'true');
      decoration.append(...submitIcon.childNodes);
      decoration.addEventListener('pointerdown', (event) => event.preventDefault());
      submitIcon.replaceWith(decoration);
    }
    let timer;
    let request;
    let previousFocus;
    let focusTimer;

    const searchUrl = overlay.dataset.searchUrl || window.routes?.search_url || '/search';
    const predictiveUrl = overlay.dataset.predictiveUrl || window.routes?.predictive_search_url || '/search/suggest';

    const allResultsUrl = (query) => `${searchUrl}?q=${encodeURIComponent(window.CabaneDiscoverySearch?.normalizeQuery(query) || query)}&type=product&options%5Bunavailable_products%5D=show`;

    const formatPrice = (value) => {
      if (value === null || value === undefined || value === '') return '';
      const source = String(value).trim();
      if (/[^\d.,\s-]/.test(source)) return source;
      const number = Number(source.replace(/\s/g, '').replace(',', '.'));
      if (!Number.isFinite(number)) return source;
      const currency = window.Shopify?.currency?.active || 'EUR';
      const locale = document.documentElement.lang || 'fr-FR';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number);
      } catch (_error) {
        return `${number.toFixed(2)} €`;
      }
    };

    const productCard = (product) => {
      const article = document.createElement('article');
      article.className = 'lcg-search-product';

      const link = document.createElement('a');
      link.className = 'lcg-search-product__link';
      link.href = product.url;

      const media = document.createElement('span');
      media.className = 'lcg-search-product__media';
      const imageSource = product.image || product.featured_image?.url || product.featured_image || product.featured_media?.preview_image?.src;
      if (imageSource) {
        const image = document.createElement('img');
        image.src = imageSource;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.width = 420;
        image.height = 525;
        media.append(image);
      }

      const copy = document.createElement('span');
      copy.className = 'lcg-search-product__copy';
      if (product.vendor) {
        const vendor = document.createElement('small');
        vendor.textContent = product.vendor;
        copy.append(vendor);
      }
      const title = document.createElement('strong');
      title.textContent = window.CabanePresentation?.title(product) || product.title || '';
      copy.append(title);
      const formattedPrice = formatPrice(product.price);
      if (formattedPrice) {
        const price = document.createElement('b');
        price.textContent = formattedPrice;
        copy.append(price);
      }

      if (product.available === false) { const availability = document.createElement("span"); availability.className = "lcg-search-product__availability"; availability.textContent = "Épuisé"; copy.append(availability); }
      link.append(media, copy);
      article.append(link);
      return article;
    };

    const suggestionLink = (query, label) => {
      const link = document.createElement('a');
      link.href = allResultsUrl(query);
      link.textContent = label || query;
      return link;
    };

    const showResults = (query, products, suggestions) => {
      resultsView.replaceChildren();
      defaultView.hidden = true;
      resultsView.hidden = false;
      const normalizedQuery = window.CabaneDiscoverySearch?.normalizeQuery(query) || query;
      if (normalizedQuery !== query) {
        const correction = document.createElement('p');
        correction.className = 'lcg-search__loading';
        correction.textContent = `Recherche pour « ${normalizedQuery} »`;
        resultsView.append(correction);
      }

      if (!products.length) {
        const empty = document.createElement('div');
        empty.className = 'lcg-search__empty';
        const title = document.createElement('strong');
        title.textContent = 'Aucun produit trouvé';
        const copy = document.createElement('span');
        copy.textContent = 'Essaie un autre mot ou explore nos catégories.';
        const link = suggestionLink(query, 'Voir tous les résultats');
        empty.append(title, copy, link);
        resultsView.append(empty);
        return;
      }

      const layout = document.createElement('div');
      layout.className = 'lcg-search__results-layout';
      const suggestionsBlock = document.createElement('section');
      const suggestionsTitle = document.createElement('h2');
      suggestionsTitle.className = 'lcg-search__eyebrow';
      suggestionsTitle.textContent = 'Suggestions';
      const suggestionsList = document.createElement('div');
      suggestionsList.className = 'lcg-search__suggestion-list';
      const uniqueSuggestions = suggestions.slice(0, 5);
      if (uniqueSuggestions.length) {
        uniqueSuggestions.forEach((item) => suggestionsList.append(suggestionLink(item.query, item.label)));
      } else {
        suggestionsList.append(suggestionLink(query, query));
      }
      suggestionsBlock.append(suggestionsTitle, suggestionsList);

      const productBlock = document.createElement('section');
      productBlock.className = 'lcg-search__product-results';
      const heading = document.createElement('div');
      heading.className = 'lcg-search__results-heading';
      const headingTitle = document.createElement('strong');
      headingTitle.textContent = 'Produits suggérés';
      const allLink = suggestionLink(query, 'Tout voir');
      heading.append(headingTitle, allLink);
      const grid = document.createElement('div');
      grid.className = 'lcg-search__products';
      products.slice(0, 8).forEach((product) => grid.append(productCard(product)));
      const viewAll = suggestionLink(query, `Voir tous les résultats pour « ${query} »`);
      viewAll.className = 'lcg-search__view-all';
      productBlock.append(heading, grid, viewAll);
      layout.append(suggestionsBlock, productBlock);
      resultsView.append(layout);
    };

    const showDefault = () => {
      window.clearTimeout(timer);
      request?.abort();
      resultsView.hidden = true;
      resultsView.replaceChildren();
      defaultView.hidden = false;
      clearButton.hidden = true;
    };

    const runSearch = async (query) => {
      request?.abort();
      request = new AbortController();
      const currentRequest = request;
      defaultView.hidden = true;
      resultsView.hidden = false;
      resultsView.replaceChildren();
      const loading = document.createElement('p');
      loading.className = 'lcg-search__loading';
      loading.setAttribute('role', 'status');
      loading.textContent = 'Recherche en cours…';
      resultsView.append(loading);

      try {
        const normalizedQuery = window.CabaneDiscoverySearch?.normalizeQuery(query) || query;
        const endpoint = `${predictiveUrl}.json?q=${encodeURIComponent(normalizedQuery)}&resources[type]=product,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=show`;
        const response = await fetch(endpoint, { signal: request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Recherche indisponible');
        const payload = await response.json();
        if (currentRequest.signal.aborted || input.value.trim() !== query) return;
        const resources = payload.resources?.results || {};
        const suggestions = (resources.queries || []).map((item) => ({
          query: item.text || item.query || query,
          label: item.text || item.query || query,
        }));
        showResults(query, resources.products || [], suggestions);
      } catch (error) {
        if (error.name !== 'AbortError' && !currentRequest.signal.aborted && input.value.trim() === query) {
          resultsView.replaceChildren();
          const message = document.createElement('p');
          message.setAttribute('role', 'status');
          message.textContent = 'Les suggestions sont momentanément indisponibles.';
          resultsView.append(message, suggestionLink(query, 'Lancer la recherche complète'));
        }
      }
    };

    let closeTimer;

    const positionSearch = () => {
      const anchor = document.querySelector('.lcg-header__search .lcg-search-trigger');
      const triggerIcon = anchor?.querySelector('svg');
      const searchIcon = overlay.querySelector('.lcg-search__form-icon');
      if (triggerIcon && searchIcon) {
        searchIcon.innerHTML = triggerIcon.innerHTML;
      }
      const desktop = anchor?.getBoundingClientRect().width > 0;
      overlay.classList.toggle('lcg-search--inline', desktop);
      overlay.setAttribute('aria-modal', desktop ? 'false' : 'true');
      if (!desktop) return;
      // Reuse the header's painted frame instead of painting a second one.
      overlay.querySelectorAll('.lcg-search__panel, .lcg-search__top, .lcg-search__form').forEach((element) => {
        element.style.setProperty('background', 'transparent', 'important');
        element.style.setProperty('box-shadow', 'none', 'important');
      });
      const box = anchor.getBoundingClientRect();
      overlay.style.setProperty('--search-left', box.left + 'px');
      overlay.style.setProperty('--search-top', box.top + 'px');
      overlay.style.setProperty('--search-width', box.width + 'px');
      overlay.style.setProperty('--search-height', Math.max(180, window.innerHeight - box.top - 20) + 'px');
    };
    document.body.append(overlay);
    window.addEventListener('resize', positionSearch);
    window.addEventListener('scroll', () => { if (!overlay.hidden) positionSearch(); }, {passive:true});
    const open = () => {
      positionSearch();
      window.clearTimeout(closeTimer);
      previousFocus = document.activeElement;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lcg-search-open');
      overlay.classList.add('is-open');
      input.focus({ preventScroll: true });
    };

    const close = () => {
      window.clearTimeout(timer);
      window.clearTimeout(focusTimer);
      request?.abort();
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lcg-search-open');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!overlay.classList.contains('is-open')) overlay.hidden = true;
        if (previousFocus instanceof HTMLElement && (!overlay.classList.contains('lcg-search--inline') || overlay.contains(document.activeElement))) previousFocus.focus({ preventScroll: true });
      }, overlay.classList.contains('lcg-search--inline') ? 0 : 380);
    };

    trigger.addEventListener('pointerdown', (event) => {
      if (event.target.closest('svg')) event.preventDefault();
    });
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      if (event.target.closest('svg')) return;
      open();
    });
    document.addEventListener('pointerdown', (event) => {
      if (!overlay.hidden && overlay.classList.contains('lcg-search--inline') && !overlay.contains(event.target) && !trigger.contains(event.target)) close();
    });
    overlay.addEventListener('focusout', () => {
      setTimeout(() => { if (!overlay.hidden && overlay.classList.contains('lcg-search--inline') && !overlay.contains(document.activeElement)) close(); }, 0);
    });
    closeButton?.addEventListener('click', close);
    backButton?.addEventListener('click', close);
    clearButton?.addEventListener('click', () => {
      input.value = '';
      showDefault();
      input.focus();
    });
    input.addEventListener('input', () => {
      request?.abort();
      const query = input.value.trim();
      clearButton.hidden = query.length === 0;
      window.clearTimeout(timer);
      if (query.length < 2) {
        showDefault();
        clearButton.hidden = query.length === 0;
        return;
      }
      timer = window.setTimeout(() => runSearch(query), 180);
    });
    form?.addEventListener('submit', (event) => {
      if (!input.value.trim()) {
        event.preventDefault();
        return;
      }
      request?.abort();
    });
    overlay.addEventListener('pointerdown', (event) => {
      if (event.target === overlay && !matchMedia('(max-width: 749px)').matches) close();
    });
    overlay.addEventListener('click', (event) => {
      if (event.target.closest('a')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (!overlay.isConnected || overlay.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab' || overlay.classList.contains('lcg-search--inline')) return;
      const focusable = [...overlay.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])')]
        .filter((element) => !element.hidden && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.querySelector?.('.lcg-search.lcg-search--v2')) return;
    document.documentElement.classList.remove('lcg-search-open');
    init();
  });
})();


